<template>
  <div>
    <v-row>
      <v-col md="12" v-if="!isViewModal">
        <v-btn size="small" color="blue-grey" prepend-icon="$plus" class="pl-4 text-white" @click="newProduct">
          <span>Agregar Detalle ASN</span>
        </v-btn>
      </v-col>

      <v-col md="12">
        <v-data-table :headers="headers" :items="asn.asn_details" style="border: solid 1px #1c1c1c" :hide-default-footer="true" :items-per-page="100">
          <template v-slot:item="{ item }">
            <tr>
              <td>
                {{ item.product.sku }}
              </td>
              <td>
                {{ item.product.name }}
              </td>
              <td>
                {{ item.expected_amount }}
              </td>
              <td v-if="requestAttributes" class="text-caption">
                {{ attributesText(item) }}
              </td>

              <td class="text-center" style="width: 110px" v-if="!isViewModal">
                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="editProduct(item)" size="small"> mdi-pencil</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="red" class="mr-2" v-on:click="_removeProduct(item, 'custom')" size="small">mdi-delete </v-icon>
                  </template>
                  <span>Remover</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div>
          <v-row class="ma-0">
            <v-col cols="12" md="6" class="pl-0"> 
              <span class="nowrap text-caption text-grey-600">
                Total de ítems: <strong class="text-black">{{ asn.asn_details.length }}</strong>
              </span>
              <span class="nowrap text-caption text-grey-600 ml-4">
                Cantidad total: <strong class="text-black">{{ totalAmount }}</strong>
              </span>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <!-- START FORM DIALOG -->
    <ModalPresentacion :dialog="dialog_presentacion" :itemEdit="itemEdit" :asn="asn" :requestAttributes="requestAttributes" @updateDialog="dialog_presentacion = false" @addProduct="_addProduct" />
  </div>
</template>

<script>
import ModalPresentacion from "./ModalPresentacion.vue";
import AliasMixin from "@/mixins/AliasMixin.vue";
import UserTypes from "@/constants/user_type";
export default {
  created() {
    this.$validator = this.validator;
  },
  mixins: [AliasMixin],
  components: { ModalPresentacion },
  props: {
    open: Boolean,
    asn: Object,
    addProduct: Function,
    removeProduct: Function,
    validator: Object,
    isViewModal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    ivas: [],
    dialog_presentacion: false,
    itemEdit: null,
    itemEditIndex: null,
  }),
  watch: {
    asn: {
      handler: function (newValue) {},
      deep: true,
    },
  },
  computed: {
    headers() {
      const headers = [
        { title: "SKU", key: "product.sku", sortable: false },
        { title: "Producto", key: "product.name", sortable: false },
        { title: "Cantidad", key: "expected_amount", sortable: false },
      ];
      if (this.requestAttributes) headers.push({ title: "Atributos", key: "attributes", sortable: false });
      if (!this.isViewModal) headers.push({ title: "Accion", sortable: false });
      return headers;
    },
    // Usuario interno: flag del cliente elegido en el ASN.
    // Usuario cliente: al crear, asn.client es null (lo asigna el backend); el flag viaja en app_object desde el login.
    requestAttributes() {
      if (this.asn.client != null) return this.asn.client.request_asn_attributes === true;
      if (localStorage.getItem("user_type") != UserTypes.CLIENT) return false;
      try {
        return JSON.parse(localStorage.getItem("app_object"))?.request_asn_attributes === true;
      } catch (e) {
        return false;
      }
    },
    totalAmount() {
      return this.asn.asn_details.reduce((sum, item) => {
        return sum + (parseFloat(item.expected_amount) || 0);
      }, 0);
    }
  },
  mounted() {},
  methods: {
    attributesText(item) {
      const parts = [];
      if (item.expected_lote) parts.push("Lote: " + item.expected_lote);
      if (item.expected_expiration_date) parts.push("Venc: " + item.expected_expiration_date);
      if (item.expected_serie) parts.push("Serie: " + item.expected_serie);
      if (item.expected_quality && item.expected_quality.name) parts.push("Calidad: " + item.expected_quality.name);
      ["descriptivo_1", "descriptivo_2", "descriptivo_3"].forEach((key) => {
        if (item[key] && this.isAliasEnabled(key)) parts.push(this.getAliasName(key) + ": " + item[key]);
      });
      return parts.length > 0 ? parts.join(" · ") : "-";
    },
    newProduct() {
      this.itemEdit = null;
      this.itemEditIndex = null;
      this.dialog_presentacion = true;
    },
    editProduct(item) {
      this.itemEditIndex = this.asn.asn_details.indexOf(item);
      this.itemEdit = Object.assign({}, item);
      this.dialog_presentacion = true;
    },
    _addProduct(item) {
      // Con control por serie el modal manda una linea por serie
      const items = Array.isArray(item) ? item : [item];

      if (this.itemEditIndex == null) {
        items.forEach((line) => this.$emit("addProduct", line));
      } else {
        this.$emit("addProduct", items[0], this.itemEditIndex);
      }
      this.dialog_presentacion = false;
    },
    _removeProduct(item, colection_name) {
      if (colection_name == "custom") {
        const index_item = this.asn.asn_details.indexOf(item);
        if (index_item > -1) this.$emit("removeProduct", index_item);
      }
    },
  },
};
</script>
